// extracted by mini-css-extract-plugin
export default {"colored-bg":"BulkUpload_colored-bg__cP1ab","btn":"BulkUpload_btn__+ARfX"};